module.exports = __webpack_public_path__ + "static/media/social-media-icons-02@2x.cecf680a.png";